import { api } from "./api";

export const getStoreInfo = async () => {
  const { data } = await api.get("/store/");
  return data;
}